var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TaxonomyTemplate',{attrs:{"taxonomy-term":"tags","taxonomy-page":_vm.taxonomyPage,"show-pills":_vm.showPills,"post-list-heading":_vm.postListHeading}})}
var staticRenderFns = []

export { render, staticRenderFns }